import { Dropdown, Icon, ICONS } from '@creditsights/styleguide-web';
import React, { ReactElement, useState } from 'react';
import classNames from 'classnames/bind';
import { OnOptionSelect } from '@creditsights/styleguide-web/components/Dropdown/Dropdown.types';
import { ItemType, NavigationItem } from '../../../../models/Navigation';
import styles from './NestedDropdown.module.scss';

const cx = classNames.bind(styles);

interface NestedDropdownProps {
  options: NavigationItem[];
  text: string;
  onSelect: OnOptionSelect;
  isLeftAligned?: boolean;
}

const renderNestedCaretIcon = (rotate: boolean) => (
  <div className={cx('icon', { rotate })}>
    <Icon name={ICONS.CaretRight} />
  </div>
);

const NestedDropdown = ({ options, text, onSelect, isLeftAligned }: NestedDropdownProps): ReactElement => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const dropdownOptions = options.map((option) => {
    const optionProps = {
      key: option.text,
      text: option.text,
      className: option.className,
    };

    if (option.type === ItemType.DROPDOWN) {
      return {
        ...optionProps,
        content: <NestedDropdown options={option.options} onSelect={onSelect} text={option.text} />,
      };
    }
    return { ...optionProps, value: option.to };
  });

  return (
    <Dropdown
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      options={dropdownOptions}
      text={text}
      onOptionSelect={onSelect}
      icon={renderNestedCaretIcon(isOpen)}
      // TODO CSNP-1951
      value={isOpen}
      isNested
      isLeftAligned={isLeftAligned}
    />
  );
};

export default NestedDropdown;
